import {
  ActivitiesSelection,
  OnboardingActivitiesSubmitValues,
} from '../OnboardingActivities.types';

export const prepareActivitiesSubmitValues = ({
  selection,
}: {
  selection: ActivitiesSelection;
}): OnboardingActivitiesSubmitValues => ({
  selectedCustomerVertical: selection.customerVerticals,
  selectedDomains: selection.domains,
  selectedReturns: { volumes: selection.volumes, methods: [], issues: [] },
  selectedCustomers: { customers: selection.customers },
});
